module.exports = __webpack_public_path__ + "static/media/ungroup_disabled.91615f83.svg";